import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-0 bg-navy" data-id="element-97" data-mp="8mn4mdpzojyr">
      <div className="mx-auto max-w-xl px-4 py-4 sm:py-8" data-id="element-98" data-mp="df6ti6u4n1iv">
        <SectionHeader onDark id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" title="Comienza hoy y organiza tus clases a tu ritmo." data-id="element-99" data-mp="id8dqv3ah6vx" />

        <div className="mt-3 rounded-xl border-[3px] border-dashed border-energy bg-white p-3.5 text-center sm:p-5" data-id="element-100" data-mp="re662g4d7pyo">
          <p className="font-condensed text-sm font-bold text-brand sm:text-base" data-id="element-101" data-mp="wd9d263wo69a">⚡ {PRODUCT_NAME}</p>
          <p className="font-numeric text-2xl leading-tight tracking-wide text-navy" data-id="element-102" data-mp="2t62tamzwao9a">6 Tomos + 5 Bonos</p>
          <p className="text-sm font-medium text-navy" data-id="element-103" data-mp="2y5fel3b4bn9r">🎁 Bonos valorados en {BONUS_TOTAL}</p>

          <p className="mx-auto mt-1.5 inline-block rounded bg-alert px-3 py-0.5 font-condensed text-sm font-bold uppercase text-white" data-id="element-104" data-mp="12ns0v29366w0">
            🔥 Oferta especial
          </p>
          <p className="mt-1 font-numeric text-6xl leading-none tracking-wide text-navy sm:text-7xl" data-id="element-105" data-mp="sxfingoqupt1">
            Hoy: <span className="text-brand" data-id="element-106" data-mp="own88k44yev6">{PRICE}</span>
          </p>
          <p className="mt-1 text-xs font-medium text-navy/70 sm:text-sm" data-id="element-107" data-mp="ouak1p7sb89o">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} className="mt-2.5" data-id="element-108" data-mp="1gocjnyf042pi">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>
          <p className="mt-1 text-xs font-medium text-navy/70" data-id="element-109" data-mp="1cniyvdwuv40u">Acceso Inmediato • Garantía de 7 Días</p>
        </div>
      </div>
    </section>;
}